import React from 'react';
import { browserHistory, Route, Router, Redirect } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { GiveawayUrl } from 'swag-common/utils/urls/giveaway.url';
import Root from 'swag-client-common/components/root';
import NotificationManager from 'swag-client-common/containers/notification-manager';
import SuccessPage from '../components/routes/success-page';
import { GiveawayInfoPage } from '../components/partials/giveaway-info-page';
import { NotFoundPage } from '../components/routes/not-found-page';
import { GiveawayLandingAdmin } from '../components/routes/giveaway-landing-admin';
import { GiveawayLandingClient } from '../components/routes/giveaway-landing-client';
import { giveawayPageResolver, GiveawayPageStatus } from '../components/partials/giveaway-page-resolver/giveaway-page-resolver';
import { onGiveawayLandingPreviewEnter, onGoodieLandingEnter } from './route-hooks';
export function giveawayRouter(store, dispatch) {
  const history = syncHistoryWithStore(browserHistory, store);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationManager, null), /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    component: Root
  }, /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.notFound(GiveawayUrl.giveawayTypeLink()),
    component: NotFoundPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayUserLandingDeleted(':link', GiveawayUrl.giveawayTypeLink()),
    component: giveawayPageResolver(GiveawayInfoPage, GiveawayPageStatus.deleted)
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayUserLandingEnded(':link', GiveawayUrl.giveawayTypeLink()),
    component: giveawayPageResolver(GiveawayInfoPage, GiveawayPageStatus.ended)
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayUserLandingSuccess(':link', GiveawayUrl.giveawayTypeLink()),
    component: giveawayPageResolver(GiveawayInfoPage, GiveawayPageStatus.completed)
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayUserLandingCheckout(':link', GiveawayUrl.giveawayTypeLink()),
    onEnter: onGoodieLandingEnter(store, dispatch),
    component: giveawayPageResolver(GiveawayLandingClient, GiveawayPageStatus.landing)
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayUserLanding({
      link: ':link',
      category: '(/:category)',
      giveawayType: GiveawayUrl.giveawayTypeLink()
    }),
    component: giveawayPageResolver(GiveawayLandingClient, GiveawayPageStatus.landing)
  }), /*#__PURE__*/React.createElement(Redirect, {
    from: "/giveaway/:link",
    to: GiveawayUrl.getGiveawayUserLanding({
      link: ':link',
      category: '(/:category)',
      giveawayType: GiveawayUrl.giveawayTypeLink()
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayPreviewSuccess(':inventoryId', ':giveawayId'),
    component: SuccessPage,
    onEnter: onGiveawayLandingPreviewEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: GiveawayUrl.getGiveawayPreview(':inventoryId', ':giveawayId'),
    component: GiveawayLandingAdmin,
    onEnter: onGiveawayLandingPreviewEnter(store, dispatch)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: NotFoundPage
  }))));
}